import styled, { css } from 'styled-components'
import { ITooltipProps } from './Tooltip.component'

export const Tip = styled.div<ITooltipProps>(({ placement, text }) => {
    const baseStyles = css`
        background-color: #003750;
        border: 1px solid #1a506c;
        border-radius: 4px;
        color: #ffffff;
        content: '${text}';
        display: none;
        font-size: 10px;
        min-width: 100%;
        padding: 3px 9px;
        position: absolute;
        text-align: center;
        width: max-content;
        z-index: 1;
    `

    const arrow = css`
        border-bottom-color: transparent;
        border-left-color: transparent;
        border-right-color: transparent;
        border-style: solid;
        border-top-color: transparent;
        border-width: 10px;
        content: '';
        display: none;
    `

    const placementStyles = {
        rightCenter: css`
            :before {
                ${baseStyles}
                left: 100%;
                top: 50%;
                transform: translateY(-50%);
            }
            :after {
                position: absolute;
                right: 0;
                top: 50%;
                ${arrow}
                transform: translateY(-50%);
                border-width: 5px;
                border-right-color: #003750;
            }
        `,
        bottomCenter: css`
            :before {
                position: absolute;
                left: 50%;
                top: 35px;
                transform: translateX(-50%);
                ${arrow}
                border-bottom-color: #1a506c;
            }
            :after {
                ${baseStyles}
                left: 50%;
                top: 50px;
                transform: translateX(-50%);
            }
        `,
        bottomEnd: css`
            :before {
                position: absolute;
                right: 50%;
                top: 35px;
                ${arrow}
                border-bottom-color: #1a506c;
            }
            :after {
                ${baseStyles}
                right: 0;
                top: 50px;
            }
        `,
        bottomStart: css`
            :before {
                left: 50%;
                position: absolute;
                top: 35px;
                ${arrow}
                border-bottom-color: #1a506c;
            }
            :after {
                ${baseStyles}
                left: 0;
                top: 50px;
            }
        `,
        topCenter: css`
            :before {
                ${baseStyles}
                left: 50%;
                top: -30px;
                transform: translateX(-50%);
            }
            :after {
                position: absolute;
                left: 50%;
                top: -15px;
                transform: translateX(-50%);
                ${arrow}
                border-top-color: #1a506c;
            }
        `,
        topEnd: css`
            :before {
                ${baseStyles}
                right: 0;
                top: -30px;
            }
            :after {
                position: absolute;
                right: 50%;
                top: -15px;
                ${arrow}
                border-top-color: #1a506c;
            }
        `,
        topStart: css`
            :before {
                ${baseStyles}
                left: 0;
                top: -30px;
            }
            :after {
                position: absolute;
                left: 50%;
                top: -15px;
                ${arrow}
                border-top-color: #1a506c;
            }
        `,
        fixedButtonRight: css`
            :before {
                ${baseStyles}
                width: max-content;
                min-width: 70px;
                position: fixed;
                top: 32px;
                right: 60px;
            }
            :after {
                position: fixed;
                top: 32px;
                right: 48px;
                ${arrow}
                border-left-color: #1a506c;
                transform: translateX(10%);
            }
        `,
    }

    return css`
        position: relative;
        :hover::before,
        :hover::after {
            display: block;
        }
        ${placementStyles[placement]};
    `
})
